import React from 'react'

export function EmptySvg() {
  return (
    <svg
      width="113"
      height="70"
      viewBox="0 0 113 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4954_11917)">
        <rect width="46" height="46" rx="10" fill="#93AAFB" />
        <path
          d="M17 21L23.5 28L30 21"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M62.3924 46.5107C63.2213 45.9142 63.2213 44.6021 62.274 44.125L51.1435 38.6378L40.013 33.1506C39.0657 32.6735 38 33.3892 38 34.4628L38.9473 46.9878L39.8946 59.5128C40.013 60.5864 41.1971 61.1828 42.0259 60.5864L48.7753 55.9343L54.6958 65L60.6163 61.0636C61.2083 60.5864 61.4451 59.7514 60.9715 59.155L55.7615 51.1628L62.3924 46.5107Z"
        fill="#292E3D"
      />
      <defs>
        <clipPath id="clip0_4954_11917">
          <rect width="46" height="46" fill="white" transform="matrix(-1 0 0 1 46 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}
